/* eslint-disable */
import React, { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import { getContext } from 'common';
import styled from './styles';

/**
 *  CellEditor is a custom cellRenderer component for active editable cell
 *  It is for to achieve the hover and focus border effect
 */
const CellEditor = forwardRef(({ value, api, ...otherProps }, ref) =>
  getContext(({ RTL, theme }) => {
    const [currentValue, setValue] = useState(value);
    const inputEl = useRef();

    const handleChange = (e) => {
      setValue(e.target.value);
    };

    // Use this hook for DataGrid related lifecycle methods. For details see: https://www.ag-grid.com/documentation/react/react-hooks/
    useImperativeHandle(ref, () => ({
      // This is for focusing on the input when user double click on an editable cell.
      afterGuiAttached() {
        // get ref from React component
        const eInput = inputEl.current;
        eInput.focus();
      },
      // This ensure returning currentValue back to grid properly.
      getValue() {
        return currentValue;
      },
      // This function is used when use is pasting value.
      setValue(val) {
        setValue(val);
      }
    }));

    return (
      <styled.EditingInput
        $rtl={RTL}
        $theme={theme.DATAGRID}
        className="defaultCellEditor"
        ref={inputEl}
        value={currentValue}
        onChange={handleChange}
        compactMode={api.context.compactMode}
        {...otherProps}
      />
    );
  }));

CellEditor.displayName = 'CellEditor';
export default CellEditor;
